export {};
//# sourceMappingURL=exclude-options.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/decorator-options/exclude-options.interface.js
// module id = 790
// module chunks = 3